import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fa',
  months: ['ژانویه', 'فوریه', 'مارس', 'آوریل', 'مه', 'ژوئن', 'ژوئیه', 'اوت', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر'],
  monthsShort: [
    'ژانویه',
    'فوریه',
    'مارس',
    'آوریل',
    'مه',
    'ژوئن',
    'ژوئیه',
    'اوت',
    'سپتامبر',
    'اکتبر',
    'نوامبر',
    'دسامبر',
  ],
  weekdays: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
  weekdaysMin: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
  weekdaysShort: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: '‏hh:mm A',
    lts: '‏hh:mm:ss A',
    L: 'YYYY/MM/DD',
    LL: '‏D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': '‏D MMMM',
    LLL: '‏D MMMM YYYY، ساعت HH:mm',
    'LLL-Y': '‏D MMMM، ساعت HH:mm',
    LLLL: 'dddd، D MMMM YYYY، ساعت HH:mm',
    'LLLL-Y': 'dddd، D MMMM، ساعت HH:mm',
    l: 'YYYY/MM/DD',
    'l-Y': 'MM/DD',
    ll: '‏D MMM YYYY',
    'll-D': 'MMM YYYY',
    'll-Y': '‏D MMM',
    'll-Y+w': 'ddd، D MMM',
    lll: '‏D MMM YYYY، ساعت hh:mm A',
    'lll-Y': '‏D MMM، ساعت hh:mm A',
    llll: 'ddd، D MMM YYYY، ساعت hh:mm A',
    'llll-Y': 'ddd، D MMM، ساعت hh:mm A',
    'LT+to': 'HH:mm ([UTC]Z)',
    'LLL+to': '‏D MMMM YYYY، ساعت HH:mm ([UTC]Z)',
  },
  meridiem: { AM: 'ق.ظ', PM: 'ب.ظ', am: 'ق.ظ', pm: 'ب.ظ' },
  past: {
    y: { one: '%s سال پیش', other: '%s سال پیش' },
    M: { one: '%s ماه پیش', other: '%s ماه پیش' },
    w: { one: '%s هفته پیش', other: '%s هفته پیش' },
    d: { one: '%s روز پیش', other: '%s روز پیش' },
    h: { one: '%s ساعت پیش', other: '%s ساعت پیش' },
    m: { one: '%s دقیقه پیش', other: '%s دقیقه پیش' },
    s: { one: '%s ثانیه پیش', other: '%s ثانیه پیش' },
  },
  future: {
    y: { one: 'تا %s سال دیگر', other: 'تا %s سال دیگر' },
    M: { one: 'تا %s ماه دیگر', other: 'تا %s ماه دیگر' },
    w: { one: 'تا %s هفته دیگر', other: 'تا %s هفته دیگر' },
    d: { one: 'تا %s روز دیگر', other: 'تا %s روز دیگر' },
    h: { one: 'تا %s ساعت دیگر', other: 'تا %s ساعت دیگر' },
    m: { one: 'تا %s دقیقه دیگر', other: 'تا %s دقیقه دیگر' },
    s: { one: 'تا %s ثانیه دیگر', other: 'تا %s ثانیه دیگر' },
  },
  pastLong: {
    y: { one: '%s سال پیش', other: '%s سال پیش' },
    M: { one: '%s ماه پیش', other: '%s ماه پیش' },
    w: { one: '%s هفته پیش', other: '%s هفته پیش' },
    d: { one: '%s روز پیش', other: '%s روز پیش' },
    h: { one: '%s ساعت پیش', other: '%s ساعت پیش' },
    m: { one: '%s دقیقه پیش', other: '%s دقیقه پیش' },
    s: { one: '%s ثانیه پیش', other: '%s ثانیه پیش' },
  },
  futureLong: {
    y: { one: 'تا %s سال دیگر', other: 'تا %s سال دیگر' },
    M: { one: 'تا %s ماه دیگر', other: 'تا %s ماه دیگر' },
    w: { one: 'تا %s هفته دیگر', other: 'تا %s هفته دیگر' },
    d: { one: 'تا %s روز دیگر', other: 'تا %s روز دیگر' },
    h: { one: 'تا %s ساعت دیگر', other: 'تا %s ساعت دیگر' },
    m: { one: 'تا %s دقیقه دیگر', other: 'تا %s دقیقه دیگر' },
    s: { one: 'تا %s ثانیه دیگر', other: 'تا %s ثانیه دیگر' },
  },
  abbr: {
    y: { one: '%s سال', other: '%s سال' },
    M: { one: '%s ماه', other: '%s ماه' },
    w: { one: '%s هفته', other: '%s هفته' },
    d: { one: '%s روز', other: '%s روز' },
    h: { one: '%s ساعت', other: '%s ساعت' },
    m: { one: '%s دقیقه', other: '%s دقیقه' },
    s: { one: '%s ثانیه', other: '%s ثانیه' },
  },
  full: {
    y: { one: '%s سال', other: '%s سال' },
    M: { one: '%s ماه', other: '%s ماه' },
    w: { one: '%s هفته', other: '%s هفته' },
    d: { one: '%s روز', other: '%s روز' },
    h: { one: '%s ساعت', other: '%s ساعت' },
    m: { one: '%s دقیقه', other: '%s دقیقه' },
    s: { one: '%s ثانیه', other: '%s ثانیه' },
  },
  justNow: 'همین الان',
  yesterday: 'دیروز',
  today: 'امروز',
  tomorrow: 'فردا',
  weekStart: 1,
  timeRange: '%$1s تا %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'hh:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: '‏D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: '‏D MMMM', end: 'D MMMM YYYY' },
    ml: { start: '‏D MMMM', end: 'D MMMM' },
    'ml-1': { start: '‏D', end: 'D MMMM YYYY' },
    dl: { start: '‏D', end: 'D MMMM' },
    y: { start: '‏D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: '‏D MMM', end: 'D MMM YYYY' },
    m: { start: '‏D MMM', end: 'D MMM' },
    'm-1': { start: '‏D', end: 'D MMM YYYY' },
    d: { start: '‏D', end: 'D MMM' },
    Y: { start: 'ddd D MMM YYYY', end: 'ddd D MMM YYYY' },
    'Y-1': { start: 'ddd D MMM', end: 'ddd D MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: '‏D MMM YYYY، ساعت HH:mm', end: 'D MMM YYYY، ساعت HH:mm' },
    mt: { start: '‏D MMM، ساعت HH:mm', end: 'D MMM، ساعت HH:mm' },
    dt: { start: '‏D MMM، ساعت HH:mm', end: 'D MMM، ساعت HH:mm' },
    t: { start: '‏HH:mm', end: 'HH:mm' },
    'yt+to': { start: '‏D MMM YYYY، ساعت HH:mm', end: 'D MMM YYYY، ساعت HH:mm ([UTC]Z)' },
    'mt+to': { start: '‏D MMM، ساعت HH:mm', end: 'D MMM، ساعت HH:mm ([UTC]Z)' },
    'dt+to': { start: '‏D MMM، ساعت HH:mm', end: 'D MMM، ساعت HH:mm ([UTC]Z)' },
    't+to': { start: '‏HH:mm', end: 'HH:mm ([UTC]Z)' },
  },
};
const localeName: LocaleName = 'fa';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'ق.ظ' : 'ق.ظ';
    } else {
      return isLowerCase ? 'ب.ظ' : 'ب.ظ';
    }
  },
};
